<template>
    <div class="editReservationPopupBg d-flex flex-column align-items-center justify-content-center" @click.self="closeSubModal">
        <div class="popupArea bg-lightest p-3">

            <div class="text-center fs-larger font-weight-600 p-3">
                Invoice Details
            </div>

            <!-- <pre>{{getSelectedInvoice}}</pre> -->
            <div class="row my-5" style="line-height: 1.5rem;">

                <div class="col-sm-6">
                    <div class="d-flex">
                        <div class="invoiceLabel dark bold">Date</div>
                        <div class="darker bold">{{formatDateDots(selectedInvoice.date)}}</div>
                    </div>
                    <div class="d-flex">
                        <div class="invoiceLabel dark bold">Number</div>
                        <div class="darker bold">{{selectedInvoice.code}}</div>
                    </div>
                    <div class="d-flex">
                        <div class="invoiceLabel dark bold">Client</div>
                        <div class="darker bold">{{selectedInvoice.name}}</div>
                    </div>

                    <div v-if="selectedInvoice.bookingRelationsQuantity && invoiceBookingsArr.length == 0" class="d-flex">
                        <div class="invoiceLabel dark bold">Linked to</div>
                        <!-- <div class="darker bold">{{selectedInvoice.bookingRelationsQuantity}} Booking{{selectedInvoice.bookingRelationsQuantity>1? 's':''}}</div> -->
                        <div class="darker bold" @click="expandBookings">

                            <div class="pointer">
                                {{selectedInvoice.bookingRelationsQuantity}} Booking{{selectedInvoice.bookingRelationsQuantity>1? 's':''}}
                                <span class="color-1">view list</span>
                            </div>


                        </div>

                    </div>


                </div>

                <div class="col-sm-6">
                    <div class="d-flex">
                        <div class="invoiceLabel dark bold">Type</div>
                        <div class="darker bold">{{selectedInvoice.type.label}}</div>
                    </div>
                    <div class="d-flex">
                        <div class="invoiceLabel dark bold">Amount</div>
                        <div class="darker bold">{{formatPrice(selectedInvoice.value)}}€</div>
                    </div>
                    <div class="d-flex">
                        <div class="invoiceLabel dark bold">VAT</div>
                        <div class="darker bold">{{selectedInvoice.vatNr}}</div>
                    </div>
                </div>

                <div class="col-sm-12">
                    <div class="invoiceBookingsHolder darker bold d-flex" v-if="invoiceBookingsArr.length > 0">
                        <div class="invoiceLabel dark bold">Linked to</div>
                        <div>
                            <div v-for="bookingRow in invoiceBookingsArr" @click.stop="openInvoiceBooking(bookingRow)" class="pointer"><span class="color-1">{{formatTicketNumber(bookingRow.sequencialNumber)}}</span> - {{bookingRow.event.product.name}}</div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Buttons -->
            <div class="d-flex w-100 justify-content-between">
                <div>
                    <button class="btn tertiary" :disabled="getIsPrintingInvoice" @click="printInvoiceClicked(selectedInvoice.id)">Print</button>
                </div>
                <div class="d-flex justify-content-end">
                    <button class="btn tertiary mr-3" @click="closeSubModal">Close</button>
                    <button class="btn action" v-if="selectedInvoice.type.id != 1" :disabled="getIsPrintingInvoice || getIsCancellingInvoice || selectedInvoice.bookingInvoiceLinkedId != null" @click="cancelInvoiceClicked(selectedInvoice)">Cancelation</button>
                </div>
            </div>


        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions} from 'vuex'
// mixins
import { invoicesMixin } from '@/mixins/invoices'

export default {
    data: function() {
        return {
            invoiceBookingsArr: []
        }
    },
    mixins: [
        invoicesMixin
    ],
    props:{
        reservation:{
            type: Object,
            default: null
        },
        invoice:{
            type: Object,
            default: null
        }
    },
    created: function() {

    },
    computed: {
        ...mapGetters([
            'getSelectedInvoice',
            'getIsCancellingInvoice',
            'getIsPrintingInvoice'
        ]),
        selectedInvoice: function() {
            return this.normalizeInvoice(this.getSelectedInvoice)
        },
    },
    methods: {
        ...mapActions([
            'cancelInvoice',
            'printInvoice',
            'getBookingsFromInvoice'
        ]),
        closeSubModal: function() {
            this.$emit('toggleInvoiceModal', 'close');
        },
        printInvoiceClicked: function (invoiceId) {
            this.printInvoice(invoiceId).then(response =>{
                if(response.status == 200){
                    this.openByteArrayNewTab(response.data)
                }

            }).catch(err => {

            })
        },
        expandBookings: function () {
            this.getBookingsFromInvoice({
                bookingInvoiceId: this.getSelectedInvoice.id
            }).then(bookingsArr => {
                this.invoiceBookingsArr = bookingsArr
            })
        },
        openInvoiceBooking: function (booking) {
            window.open('/reservations/view/'+booking.sequencialNumber, '_blank');
        },
        cancelInvoiceClicked: function (invoice) {
            // let vm = this

            this.$dialog.confirm('You are about to cancel this invoice thus generating a Credit Note, are you sure?').then(() => {
                this.cancelInvoice({
                    invoice: invoice,
                    booking: this.reservation
                }).then(response => {

                    // everyting worked ok, we remove set the linkedInvoice (this means that it was canceled and now has a credit note)
                    this.getSelectedInvoice.bookingInvoiceLinkedId = response.data.id

                    this.reservation.bookingInvoices.push(response.data)

                    this.$emit('invoiceCancelled', response.data)
                    this.toggleModal()
                    //this.openByteArrayNewTab(response.data)

                })
            })
            .catch(function () {
            })
        },
        pressDone: function() {
            this.toggleModal()
        },
        toggleModal: function () {
            this.$emit('toggleInvoiceModal', this.selectedSeller)
        }
    },
    components: {
    }
}

</script>

<style lang="scss" scoped>

@import '../../assets/scss/_variables.scss';

.editReservationPopupBg{
    background-color: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
    z-index: 20 !important;
    position: absolute;

    .popupArea{
        width: 620px;
        max-height: 100%;
        max-width: 100%;
        margin: 0 auto;
        // overflow: auto;


        .invoiceBookingsHolder{
            max-height: 300px;
            overflow-y: auto;
        }

    }
}

.invoiceLabel{
    width: 100px;
}

</style>



// WEBPACK FOOTER //
// InvoiceModal.vue?65095000